export const MOCKING_ENABLED = import.meta.env.VITE_MOCKING_ENABLED === 'true';
export const SOLUTION_ENDPOINT = import.meta.env.VITE_SOLUTION_ENDPOINT;
